import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route, withRouter } from 'react-router-dom';
import CurrentForecastPage from './CurrentForecastPage';

function ForecastPage() {
  return (
    <Switch>
      <Route path="/forecast/current/weighted" component={CurrentForecastPage} />
      <Route exact path="/forecast/current" component={CurrentForecastPage} />
    </Switch>
  );
}

ForecastPage.propTypes = {
};

ForecastPage.contextTypes = {
  router: PropTypes.object,
};
export default withRouter(ForecastPage);
